import { UserPlus, Mail, UserCog, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import { Badge } from "@/components/ui/badge";
import React from "react";

interface ProjectTeamProps {
  projectId: string;
  loading?: boolean;
}

export default function ProjectTeam({ loading = false }: ProjectTeamProps) {
  if (loading) {
    return (
      <div className="mt-6 space-y-6">
        <div className="bg-muted animate-pulse rounded-md h-10 w-48 mb-4" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-muted animate-pulse rounded-md h-24" />
          <div className="bg-muted animate-pulse rounded-md h-24" />
          <div className="bg-muted animate-pulse rounded-md h-24" />
        </div>
      </div>
    );
  }

  // Mock team members for the UI display
  const teamMembers = [
    {
      id: "1",
      name: "Alex Johnson",
      email: "alex.johnson@example.com",
      role: "Project Manager",
      avatar: "",
    },
    {
      id: "2",
      name: "Sam Rivera",
      email: "sam.rivera@example.com",
      role: "Claims Reviewer",
      avatar: "",
    },
    {
      id: "3",
      name: "Jamie Smith",
      email: "jamie.smith@example.com",
      role: "Document Specialist",
      avatar: "",
    },
  ];

  return (
    <div className="mt-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-neutral-800">Project Team</h2>
        <Button>
          <UserPlus className="mr-2 h-4 w-4" />
          Invite Team Member
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {teamMembers.map((member) => (
          <Card key={member.id} className="overflow-hidden">
            <CardContent className="p-4">
              <div className="flex items-center space-x-4">
                <Avatar className="h-12 w-12">
                  <AvatarImage src={member.avatar} alt={member.name} />
                  <AvatarFallback className="bg-primary/10 text-primary">
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-neutral-900 truncate">
                    {member.name}
                  </p>
                  <p className="text-xs text-neutral-500 truncate flex items-center">
                    <Mail className="mr-1 h-3 w-3" />
                    {member.email}
                  </p>
                  <Badge variant="outline" className="mt-1.5 text-xs">
                    {member.role}
                  </Badge>
                </div>
                <Button variant="ghost" size="icon">
                  <UserCog className="h-4 w-4" />
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      
      <div className="mt-10">
        <h3 className="text-lg font-medium mb-4 flex items-center">
          <Shield className="mr-2 h-5 w-5 text-primary" />
          Access Control
        </h3>
        <p className="text-sm text-neutral-500 mb-4">
          Team management and access control features will be available in the next update.
        </p>
      </div>
    </div>
  );
}